import React from 'react';

import { useDispatch } from 'react-redux';
import { changeCustomFieldFilters } from '../store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';

import DateFilter from './date_filter';
import NumberFilter from './number_filter';
import SelectFilter from './select_filter';
import StringFilter from './string_filter';

import type { CustomFieldSchema } from 'bundles/crm/types';
import type { Filter } from './types';

const componentsByValueType = {
  date: DateFilter,
  enum_value: SelectFilter,
  float: NumberFilter,
  string: StringFilter,
};

interface Props {
  filter: Filter;
  schema: CustomFieldSchema;
}

export default function CompsCustomFieldFilter({ filter, schema }: Props) {
  const dispatch = useDispatch();

  const Component = componentsByValueType[schema.valueType] || StringFilter;

  function changeFilter(filter: Filter) {
    dispatch(changeCustomFieldFilters({ [schema.slug]: filter }));
    dispatch(delayRetrieveRecords());
  }

  return (
    <Component
      filter={filter}
      schema={schema}
      onChange={changeFilter}
    />
  );
}
